import { Box, useMediaQuery } from "@mui/material";
import moment from "moment";
import React from "react";
import { CountdownCircleTimer } from "react-countdown-circle-timer";

const minuteSeconds = 60;
const hourSeconds = 3600;
const daySeconds = 86400;

const renderTime = (dimension, time, matches) => {
  return (
    <Box textAlign="center">
      <Box fontSize={matches ? "8px" : "10px"} color="#ffffff" fontWeight={700}>
        {time}
      </Box>
      <Box fontSize={matches ? "8px" : "10px"} color="#ffffff" fontWeight={700}>
        {dimension}
      </Box>
    </Box>
  );
};

const getTimeSeconds = (time) => (minuteSeconds - time) | 0;
const getTimeMinutes = (time) => ((time % hourSeconds) / minuteSeconds) | 0;
const getTimeHours = (time) => ((time % daySeconds) / hourSeconds) | 0;
const getTimeDays = (time) => (time / daySeconds) | 0;

export default function WithdrawalTimer({ endTime }) {
  const matches = useMediaQuery("(max-width:750px)");
  const stratTime = moment().format("X");

  const remainingTime = endTime - stratTime;
  const days = Math.ceil(remainingTime / daySeconds);
  const daysDuration = days * daySeconds;

  const timerProps = {
    isPlaying: true,
    size: matches ? 40 : 40,
    strokeWidth: 3,
  };
  return (
    <Box
      display="flex"
      justifyContent={{ xs: "center", sm: "space-between" }}
      fontFamily="sans-serif"
      textAlign="center"
      flexWrap="wrap"
    >
      <CountdownCircleTimer
        {...timerProps}
        colors={[["#7E2E84"]]}
        duration={daysDuration}
        initialRemainingTime={remainingTime}
      >
        {({ elapsedTime }) =>
          renderTime("D", getTimeDays(daysDuration - elapsedTime), matches)
        }
      </CountdownCircleTimer>
      <CountdownCircleTimer
        {...timerProps}
        colors={[["#D14081"]]}
        duration={daySeconds}
        initialRemainingTime={remainingTime % daySeconds}
        onComplete={(totalElapsedTime) => [
          remainingTime - totalElapsedTime > hourSeconds,
        ]}
      >
        {({ elapsedTime }) =>
          renderTime("H", getTimeHours(daySeconds - elapsedTime), matches)
        }
      </CountdownCircleTimer>
      <CountdownCircleTimer
        {...timerProps}
        colors={[["#EF798A"]]}
        duration={hourSeconds}
        initialRemainingTime={remainingTime % hourSeconds}
        onComplete={(totalElapsedTime) => [
          remainingTime - totalElapsedTime > minuteSeconds,
        ]}
      >
        {({ elapsedTime }) =>
          renderTime("M", getTimeMinutes(hourSeconds - elapsedTime), matches)
        }
      </CountdownCircleTimer>
      <CountdownCircleTimer
        {...timerProps}
        colors={[["#218380"]]}
        duration={minuteSeconds}
        initialRemainingTime={remainingTime % minuteSeconds}
        onComplete={(totalElapsedTime) => [
          remainingTime - totalElapsedTime > 0,
        ]}
      >
        {({ elapsedTime }) =>
          renderTime("S", getTimeSeconds(elapsedTime), matches)
        }
      </CountdownCircleTimer>
    </Box>
  );
}
